import { ArrowUpRight } from "lucide-react";
import { ScrollReveal, SectionLabel } from "./Reveal";
import { LINKS } from "@/constants/links";

export const AboutSection = () => {
  const socials = [
    { label: "YouTube", href: LINKS.youtube },
    { label: "Instagram", href: LINKS.instagram },
    { label: "TikTok", href: LINKS.tiktok },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <ScrollReveal>
          <SectionLabel index="09" title="About" />
          <h2 className="font-display leading-[0.95] text-[11vw] sm:text-[8vw] lg:text-[6vw]">
            I'm <span className="text-outline">Jacques.</span>
          </h2>
        </ScrollReveal>

        <div className="mt-12 grid lg:grid-cols-2 gap-12 items-start">
          <ScrollReveal delay={0.1}>
            {LINKS.portrait ? (
              <div className="aspect-[4/5] overflow-hidden border border-white/10" data-testid="about-portrait">
                <img src={LINKS.portrait} alt="Jacques — Etia Media" className="w-full h-full object-cover" />
              </div>
            ) : (
              <div
                data-testid="about-portrait"
                className="aspect-[4/5] border border-white/10 bg-[#111111] flex flex-col items-center justify-center gap-6 select-none"
              >
                <span className="font-display text-[10rem] leading-none text-outline">J</span>
                <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#55554F] text-center px-8">
                  Portrait of Jacques — drop the photo link into links.js
                </span>
              </div>
            )}
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <div className="space-y-5 text-base md:text-lg text-[#8A8A85] leading-relaxed">
              <p>I'm a filmmaker, storyteller and content creator based in the UK.</p>
              <p>I'm interested in real people, ambitious businesses and stories that deserve to be told properly.</p>
              <p>
                My approach combines cinematic filmmaking with social-first content —
                creating films that don't just look good, but give people a reason to
                stop scrolling.
              </p>
              <p>
                And it doesn't stop at the shoot — I run the social media and ads too,
                so the work actually gets seen.
              </p>
            </div>
            <div className="mt-10 flex flex-wrap gap-8">
              {socials.map((s) => (
                <a
                  key={s.label}
                  data-testid={`about-social-${s.label.toLowerCase()}`}
                  href={s.href}
                  target={s.href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  onClick={s.href === "#" ? (e) => e.preventDefault() : undefined}
                  className="group flex items-center gap-2 font-mono2 text-xs uppercase tracking-[0.25em] text-[#F2F0EB] hover:text-[#8A8A85] transition-colors duration-300"
                >
                  {s.label}
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                </a>
              ))}
            </div>
          </ScrollReveal>
        </div>

        <ScrollReveal delay={0.1}>
          <p className="font-display text-[22vw] lg:text-[12vw] leading-none text-outline text-right select-none mt-8">Jacques</p>
        </ScrollReveal>
      </div>
    </section>
  );
};
